<template>
  <div id="projectNew">

    <!-- Spinner -->
    <loading :active.sync="loading"></loading>
    <!-- /Spinner -->
    <!-- Form -->
    <chatter-form @isChangedForm="(value) => isChangedForm = value" ref="form" :id="-1"></chatter-form>
    <!-- /Form -->

    <!-- Buttons -->
    <div class="chatter-btn-wrap justify-content-end" :class="{ 'bottom': isPageEnd }">
      <div class="button-container">

        <base-button size="sm" variant="default" @click="cancel">Cancel</base-button>
        <base-button :disabled="!isChangedForm" variant="primary" @click="submit">Write</base-button>
        
        <!-- <b-button @click="cancel" type="button">Cancel</b-button>
        <b-button :disabled="!isChangedForm" @click="submit()" variant="primary" class="mr-1">Write</b-button> -->
      </div>
    </div>
    <!-- /Buttons -->
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import ChatterForm from './ChatterProjectForm.vue';
import BaseButton from '../requirement/BaseButton.vue';

export default ({
  components: { Loading, ChatterForm, BaseButton},
  data() {
    return {
      loading: false,
      title: '',
      // chatter-btn-wrap 페이지 끝 도달 시 클래스 부여 위해 추가함
      isPageEnd: false,
      isChangedForm: false,
    }
  },
  mounted() {
    this.$refs.form.load();
    // chatter-btn-wrap 페이지 끝 도달 시 클래스 부여 위해 추가함
    window.addEventListener('scroll', this.handleScroll)
    // 스크롤 시 chatter-top-area의 title 노출 이벤트 위해 추가
    window.addEventListener('scroll', this.showTitle)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);

    // chatter-btn-wrap 페이지 끝 도달 시 클래스 부여 위해 추가함
    window.removeEventListener('scroll', this.handleScroll);
    // 스크롤 시 chatter-top-area의 title 노출 이벤트 위해 추가
    window.removeEventListener('scroll', this.showTitle)
  },
  methods: {
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref);
      }
      return null;
    },
    titleModify() {
      this.$refs.form.modifyTitle(this.title);
    },
    async cancel() {
      if(this.isChangedForm) {
        if (await this.showConfirm('작성된 내용이 저장되지 않았습니다. 페이지를 이동하시겠습니까?')) {
          this.pushRoute('/chatter/chatter-project-list');
        } else {
          return;
        }
      }
      this.pushRoute('/chatter/chatter-project-list')
    },
    async submit() {
      await this.$validator.validate();
      try {
        this.loading = true;

        // Call submit method of ChatterForm
        //this.titleModify();
        const {status, message, body} = await this.$refs.form.submit();

        if (status === "200") {
          const createdProjectId = body.id;

          this.showToast("프로젝트가 생성되었습니다.");

          await this.$store.dispatch('chatter/retrieveAllProjectInfo', 'update');
          this.$router.replace(`/chatter/project/${createdProjectId}`);
        } else {
          this.showToast(message, "danger", 2000);
        }
        // this.pushRoute('/chatter/chatter-project-list');

      } catch (error) {
        // error.message === 400 means validation failed
        if (error.message !== '400') {
          this.showError(error);
        }
      } finally {
        this.loading = false;
      }
    },
    handleScroll() {
      const scrollPosition = document.documentElement.scrollTop;
      if ((scrollPosition + window.innerHeight) >= document.body.scrollHeight) {
        this.isPageEnd = true;
      } else {
        this.isPageEnd = false;
      }
    },
  }
})
</script>

<style>
#projectNew span.required {
  color: red;
}

#projectNew .image-title {
  display: block;
  margin-bottom: .3rem;
}

#projectNew .image-box {
  display: block;
  max-width: 100%;
}

#projectNew .hide-toolbar .ql-toolbar {
  display: none;
}

#projectNew .hide-border .ql-container {
  border: none !important;
}

#projectNew .custom-input {
  height: 2rem !important;
  line-height: 1.0 !important;
}

#projectNew .custom-tags {
  height: 1.1rem !important;
}

#projectNew .card-header {
  padding-left: 1rem;
}

#projectNew .button-container {
  white-space: nowrap;
  /* 텍스트가 줄바꿈되지 않도록 설정 */
  overflow: hidden;
  /* 너비를 초과하는 텍스트를 감추기 */
  margin: 0.2em;
  padding: 0.2em;
}

#projectNew .btn {
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

#projectNew .btn:focus {
  box-shadow: none;
}

#projectNew .btn-primary {
  width: 280px;
  height: 60px;
  background-color: #2E2E38;
  color: #FFE600;
  border-color: transparent;
}

#projectNew .btn-primary:hover {
  color: #FFE600;
  background-color: #0D0D17;
  border-color: transparent;
}

#projectNew .btn-primary.disabled,
#projectNew .btn-primary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

#projectNew .btn-secondary {
  width: 146px;
  height: 60px;
  border-radius: 10px;
  background: #747480;
  color: #fff;
}

#projectNew .btn-secondary.small {
  height: 40px;
}

#projectNew .btn-secondary:hover {
  background-color: #565662;
}

#projectNew .btn-secondary.disabled,
#projectNew .btn-secondary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

#projectNew .btn-sub-primary {
  width: 140px;
  height: 60px;
  background-color: #2E2E38;
  border: none;
  color: #FFF;
}

#projectNew .btn-sub-primary:hover {
  background-color: #0D0D17;
}

#projectNew .btn-sub-primary.disabled,
#projectNew .btn-sub-primary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

#projectNew .btn-line {
  position: relative;
  width: 100px;
  height: 60px;
  border: 1px solid #C4C4CD;
  background-color: transparent;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  text-align: inherit;
}

#projectNew .btn-line:hover {
  color: #2E2E38;
  border: 1px solid #2E2E38;
  background-color: transparent;
}

#projectNew .btn-line.disabled,
#projectNew .btn-line:disabled {
  border: 1px solid #DDDDE3;
  background-color: transparent;
}

#projectNew .btn-line.small {
  height: 40px;
}

#projectNew .btn-line.prev {
  padding: 0 1.866rem 0 2.866rem;
}

#projectNew .btn-line.prev::before {
  content: '';
  display: block;
  position: absolute;
  left: 1.133rem;
  top: 1.466rem;
  width: 16px;
  height: 16px;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10.5 2L4.5 8L10.5 14" stroke="%232E2E38" stroke-linecap="round"/></svg>') center no-repeat;
}

#projectNew .btn-line.prev.disabled::before,
#projectNew .btn-line.prev:disabled::before {
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10.5 2L4.5 8L10.5 14" stroke="%23DDDDE3" stroke-linecap="round"/></svg>') center no-repeat;
}

#projectNew .btn-line.next {
  padding: 0 2.866rem 0 1.866rem;
}

#projectNew .btn-line.next::before {
  content: '';
  display: block;
  position: absolute;
  right: 1.133rem;
  top: 1.466rem;
  width: 16px;
  height: 16px;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none"><path d="M6 14L12 8L6 2" stroke="%232E2E38" stroke-linecap="round"/></svg>') center no-repeat;
}

#projectNew .btn-line.next.disabled::before,
#projectNew .btn-line.next:disabled::before {
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none"><path d="M6 14L12 8L6 2" stroke="%23DDDDE3" stroke-linecap="round"/></svg>') center no-repeat;
}

#projectNew .btn-delete,
#projectNew .badge-container .btn-delete {
  width: 16px;
  height: 16px;
  font-size: 0 !important;
  background: transparent url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12 12L4 4" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 4L4 12" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center/16px 16px no-repeat;
}

#projectNew .btn-card-fold {
  position: absolute;
  top: 2rem;
  right: 2.666rem;
  display: block;
  width: 30px;
  height: 30px;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M23.75 18.75L15 10L6.25 18.75" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
  border: none;
  z-index: 100;
}

#projectNew .btn-card-fold.fold {
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M23.75 11.25L15 20L6.25 11.25" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
}

#projectNew .chatter-btn-wrap {
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 1.333rem 3.125vw;
  gap: 0.666rem;
  align-items: center;
  margin-left: -3.125vw;
  margin-right: -3.125vw;
  z-index: 999;
  background-color: #f6f6fa;
  box-shadow: 0px -10px 30px 0px rgba(46, 46, 56, 0.14);
}

#projectNew .chatter-btn-wrap.bottom {
  box-shadow: none;
}


#projectNew .chatter-btn-wrap .button-container {
  display: flex;
  gap: 0 10px;
  margin: 0;
  padding: 0;
}
</style>